import {StaticImageData} from 'next/image';
import {TSize} from './image-modify';

/* проверяет что бы переданный путь src был строкой */
export const isImageStatic = (
    image: StaticImageData | string,
): image is string => {
    return typeof image === 'string';
};

const sizes = {
    sm: 160,
    md: 360,
    lg: 660,
};

/* изменяет путь передаваемый в путь для картинки */
export const newUrl = (src: string, size: TSize) => {
    return src.replace('jpg', `thumbnail_${sizes[size]}.jpg`)
};
